var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t8pvyjjd2a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t8pvyjjd2a)",
    transform: "translate(-640 -2332) translate(0 2170) translate(360 67) translate(0 85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M5.969.936L.629 3.072C.249 3.224 0 3.591 0 4v14c0 .707.714 1.19 1.371.928l4.66-1.864 6 2 5.34-2.136c.38-.152.629-.519.629-.928V2c0-.707-.714-1.19-1.371-.928l-4.66 1.864-6-2zM7 3.386l4 1.335v11.892L7 15.28V3.387zm-2 .09v11.846l-3 1.201V4.678l3-1.201zm11 0v11.846l-3 1.201V4.678l3-1.201z",
    transform: "translate(280 10)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMap);
export default __webpack_public_path__ + "static/media/icons-map.a08a6fe1bd751240a4ef7144e99edd50.svg";
export { ForwardRef as ReactComponent };